import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AppSettings } from "../../config/app-settings.js";

/** Horizontal logo — dark green "POND" text for light backgrounds. */
export const PONDSTAT_LOGO_SRC =
  "/assets/img/PondStatLogo1600x425TransparentBackground.png";

/** Same layout with white "POND" + tagline for dark backgrounds. */
export const PONDSTAT_LOGO_DARK_SRC =
  "/assets/img/PondStatLogo1600x425TransparentBackgroundDarkMode.png";

export function PondStatBrandLogo({ className = "donezo-brand-logo", alt }) {
  const { appDarkMode } = useContext(AppSettings);
  const src = appDarkMode ? PONDSTAT_LOGO_DARK_SRC : PONDSTAT_LOGO_SRC;

  return (
    <img
      src={src}
      alt={alt || "PondStat — Fishery Statistics Made Easy"}
      className={className}
    />
  );
}

const SidebarBrand = () => {
  const { appSidebarMinify } = useContext(AppSettings);

  return (
    <Link to="/dashboard" className="donezo-sidebar-brand">
      {appSidebarMinify ? (
        <span className="donezo-sidebar-brand-icon" aria-hidden>
          <i className="fa fa-fish" />
        </span>
      ) : (
        <PondStatBrandLogo />
      )}
    </Link>
  );
};

export default SidebarBrand;
